import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';

import { Wrapper } from './SyncedIcon.styles';

import { useProfile } from '@/store';

interface Props {
  size?: number;
}

export const SyncedIcon: React.FC<Props> = ({ size = 20 }) => {
  const { t } = useTranslation('CourseTranslations');
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!isManager) return null;

  return (
    <div>
      <Tooltip title={t('SYNCED_CONTENT')}>
        <Wrapper>
          <Icon i="Renew" size={size} />
        </Wrapper>
      </Tooltip>
    </div>
  );
};
